import getConfig from 'next/config'

import { GoogleMapsSettings, MarkerClusters, Pin } from '@grandvisionhq/common'
import { Components } from '@grandvisionhq/stores-v2'

const { publicRuntimeConfig } = getConfig()
const gmKey = publicRuntimeConfig.googleMaps.apiKey ?? ''
const gmCenter = publicRuntimeConfig.googleMaps.mapCenter ?? {}

const { PreferredStorePin } = Components

const pinThemes = {
  primary: { foreground: '#ffffff', background: '#eb4233' },
  highlight: { foreground: '#ffffff', background: '#82170d' },
  hovered: { foreground: '#d52515', background: '#ffffff' },
}

export const getGoogleMapsConfig = (): GoogleMapsSettings => ({
  apiKey: gmKey,
  defaultCenter: gmCenter,
  defaultZoom: 8,
  pin: Pin({
    themes: pinThemes,
  }),
  preferredStorePin: PreferredStorePin({
    themes: pinThemes,
  }),
  markerClusterOptions: MarkerClusters({
    theme: {
      color: '#009878',
      textColor: '#ffffff',
    },
    minimumClusterSize: 3,
    maxZoom: 10,
  }),
})
